import { enUS, es, ptBR } from 'react-day-picker/locale';
import {
  formatCalendarDay,
  formatMonthCaption,
  dateLocale,
  weekdayLong,
  weekdayNarrow,
} from '@voll-intelligence/dates';

/** Maps a BCP 47 tag (`pt-BR`, `en-US`, `es`) to the `react-day-picker` locale the
 *  ui-kit `Calendar` expects. Only the language subtag matters; anything that is not
 *  English or Spanish falls back to Brazilian Portuguese, the product default. The
 *  locales ship inside `react-day-picker`, so consumers need no `date-fns` of their own. */
export function calendarLocale(locale: string) {
  const language = dateLocale(locale);
  if (language === 'en') return enUS;
  if (language === 'es') return es;
  return ptBR;
}

/** Os formatadores de legenda e de dia da semana que todo calendário de viagem
 *  do kit usa (hotel e rent a car): "Setembro 2026" e o dia da semana em UMA
 *  letra maiúscula, das tabelas do módulo de datas. */
export function calendarFormatters(locale: string) {
  return {
    formatCaption: (date: Date) => formatMonthCaption(date, locale),
    formatWeekdayName: (date: Date) => weekdayNarrow(date, locale),
  };
}

/** Os rótulos das setas, do dia da semana (por extenso) e do dia — o `labels`
 *  do `Calendar`. */
export function calendarLabels(locale: string, previousMonthLabel: string, nextMonthLabel: string) {
  return {
    labelPrevious: () => previousMonthLabel,
    labelNext: () => nextMonthLabel,
    labelWeekday: (date: Date) => weekdayLong(date, locale),
    labelDayButton: (date: Date) => formatCalendarDay(date, locale),
  };
}
